import { render, staticRenderFns } from "./SettingByShoppingMall.vue?vue&type=template&id=46d26400&scoped=true&"
import script from "./SettingByShoppingMall.vue?vue&type=script&lang=ts&"
export * from "./SettingByShoppingMall.vue?vue&type=script&lang=ts&"
import style0 from "./SettingByShoppingMall.vue?vue&type=style&index=0&id=46d26400&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d26400",
  null
  
)

export default component.exports